import { appEntry } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 text-primary-400 text-xs font-semibold mb-4">
              <i className="ri-smartphone-line"></i>
              APP下载
            </span>
            <h2 className="text-2xl md:text-3xl font-display text-background-50">{appEntry.title}</h2>
            <p className="mt-2 text-lg text-primary-400 font-semibold">{appEntry.subtitle}</p>
            <p className="mt-4 text-sm text-background-300 leading-relaxed max-w-md mx-auto lg:mx-0">{appEntry.desc}</p>

            <div className="mt-6 grid grid-cols-2 gap-3 max-w-md mx-auto lg:mx-0">
              {appEntry.features.map((f, i) => (
                <div key={i} className="flex items-center gap-2 text-xs text-background-300">
                  <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
                  {f}
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a href="#" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-foreground-900 font-semibold text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill text-lg"></i> App Store
              </a>
              <a href="#" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-google-play-fill text-lg"></i> Google Play
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-xs lg:max-w-none flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-primary-500/20 rounded-3xl blur-3xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=smartphone%20mockup%20displaying%20a%20dark%20theme%20news%20app%20with%20red%20accent%20headlines%20about%20scandals%20and%20breaking%20news%2C%20modern%20mobile%20UI%20design%2C%20dark%20background%20with%20crimson%20highlights%2C%20product%20photography%20style&width=400&height=700&seq=app-mockup-2026&orientation=portrait"
                alt="每日大赛黑料 APP 随时随地吃瓜"
                className="relative w-48 md:w-56 h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}